module.exports = __webpack_public_path__ + "static/slide3-318x245-d1bb5399e6065c0745a56ca5ee7ec13b.gif";